import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { statusChanged } from "../redux/filter/actions";

const BookFilter = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.filters);

  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>

      <div className="flex items-center space-x-4">
        <button
          className={`filter-btn ${
            filters.status === "All" && "active-filter"
          }`}
          id="lws-filterAll"
          onClick={() => dispatch(statusChanged("All"))}
        >
          All
        </button>
        <button
          className={`filter-btn ${
            filters.status === "Featured" && "active-filter"
          }`}
          id="lws-filterFeatured"
          onClick={() => dispatch(statusChanged("Featured"))}
        >
          Featured
        </button>
      </div>
    </div>
  );
};

export default BookFilter;
